import { useQuery } from '@tanstack/react-query'
import req from '@sportninja/common/api/request'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import { PlayerData, PlayerHighlight } from '../types'

const fetchPlayer = async (playerId: string): Promise<PlayerData> => {
  const response = await req(`/players/${playerId}`)
  return response.data
}

const fetchHighlights = async (
  playerId: string
): Promise<PlayerHighlight[]> => {
  try {
    const response = await req(`/players/${playerId}/highlights`)
    return response?.data?.length > 0 ? response.data : []
  } catch {
    return []
  }
}

/**
 * GET /players/:id — cached via React Query so re-mounts (e.g. switching
 * Profile tabs that each wrap their own PlayerProvider) reuse the same data
 * instead of refetching.
 */
export function usePlayerQuery(playerId: string) {
  return useQuery<PlayerData>({
    queryKey: queryKeys.player.byId(playerId),
    queryFn: () => fetchPlayer(playerId),
    enabled: Boolean(playerId),
  })
}

/** GET /players/:id/highlights — cached per player. */
export function usePlayerHighlightsQuery(playerId: string) {
  return useQuery<PlayerHighlight[]>({
    queryKey: queryKeys.playerHighlights.byPlayer(playerId),
    queryFn: () => fetchHighlights(playerId),
    enabled: Boolean(playerId),
  })
}
